// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.SetpointModal_form__J7P5P {
  width: 45rem;
}
@media only screen and (max-width: 768px) {
  .SetpointModal_form__J7P5P {
    max-width: 100%;
  }
}

.SetpointModal_container__VtMav {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.SetpointModal_header__zJ0YY {
  width: 100%;
  padding-top: 0.5rem;
}

.SetpointModal_slider-info__aTSr2 {
  width: 70%;
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}
.SetpointModal_slider-info__aTSr2 label {
  vertical-align: middle;
  margin-left: 0.5em;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/NodeInfo/SetpointModal/SetpointModal.module.scss","webpack://./src/utils/_utils.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;AEzBA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AD/BA;EACE,YAAA;AAsBF;AApBE;EAHF;IAII,eAAA;EAuBF;AACF;;AApBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAuBF;;AApBA;EACE,WAAA;EACA,mBAAA;AAuBF;;AApBA;EACE,UAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;AAuBF;AArBE;EACE,sBAAA;EACA,kBAAA;AAuBJ","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.form {\n  width: 45rem;\n}\n@media only screen and (max-width: 768px) {\n  .form {\n    max-width: 100%;\n  }\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.header {\n  width: 100%;\n  padding-top: 0.5rem;\n}\n\n.slider-info {\n  width: 70%;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n}\n.slider-info label {\n  vertical-align: middle;\n  margin-left: 0.5em;\n}",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `SetpointModal_form__J7P5P`,
	"container": `SetpointModal_container__VtMav`,
	"header": `SetpointModal_header__zJ0YY`,
	"slider-info": `SetpointModal_slider-info__aTSr2`
};
export default ___CSS_LOADER_EXPORT___;
